export const mockAPIPath = {
    VARIATION_LIST: "./data/productList.json",
    PRODUCT_LIST_SEARCH:"",
    EDIT_PRODUCT_VARIATION:""
};

export const serverAPIPath = {
    VARIATION_LIST: "/products/variations",
    PRODUCT_LIST_SEARCH: "/products/variations/search",
    EDIT_PRODUCT_VARIATION:"/products/variations"
};
